import { Navigate } from "react-router-dom";
import { usePersistStore } from "../../store";
import { consumePostLoginRedirect } from "../../utils/postLoginRedirect";

const ProtectedAuthRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, token } = usePersistStore((s: any) => s);
  let authenticate = user && token;

  if (!authenticate) return <>{children}</>;

  // Already logged in but landed on /login or /register — typical when
  // the user clicks an email link with `?redirectTo=` while they still
  // have an active session. Send them straight to the requested page.
  const target = consumePostLoginRedirect("/");
  return <Navigate to={target} replace />;
};

export default ProtectedAuthRoute;
